/**
 * Some capture paths (quick capture, blank-email quick add) stamp a synthetic
 * address into `Client.email` because the column is non-nullable. Those are not
 * real addresses — never show them to a user or seed them into an edit form,
 * or the field looks filled in when the lead actually has no email.
 *
 * Keep in sync with the backend generators in `crm/quick_capture_views.py` and
 * `ClientSerializer.create`.
 */
const PLACEHOLDER_EMAIL_DOMAIN = '@placeholder.launchpoint.invalid';

export function isPlaceholderEmail(email: string | null | undefined): boolean {
  return (email || '').trim().toLowerCase().endsWith(PLACEHOLDER_EMAIL_DOMAIN);
}

/** The address to show/edit: '' when it is a synthetic placeholder. */
export function displayEmail(email: string | null | undefined): string {
  const value = (email || '').trim();
  return isPlaceholderEmail(value) ? '' : value;
}
